export const grade = {
  href: '/sam/commons/studyprogrammegroups/types/16212f35-a563-48a0-a453-76bf06f0b6ee',
};
